import { useAct } from 'DashboardBuilder/store'
import Loading from 'Shared/components/Loading'
import EditableName from 'Shared/components/EditableName/EditableName'
import Effort from './Steps/Effort'
import Instructions from './Steps/Instructions'
import DashboardFields from './Steps/DashboardFields'
import Settings from './Steps/Settings'
import Preview from './Steps/Preview'
import DashboardAccessAndAudience from './Steps/DashboardAccessAndAudience'
import ManageMenuComponent from 'Shared/components/ManageMenu/ManageMenuComponent'
import { ManageMenuItem } from 'Shared/components/ManageMenu'
import restClient from 'Shared/hooks/restClient'

export default function Builder({ dashboardId }) {
  const act = useAct()
  const { loaded } = useSel((s) => s.builder)
  const { name, status } = useSel((s) => s.dashboard)

  useEffect(() => {
    act.builder.load(dashboardId)
    act.builder.loadMergeTags()
  }, [dashboardId])

  function archiveDashboard() {
    restClient.post(`/api/dashboards/${dashboardId}/archive`).then(() => {
      window.location.href = '/admin/dashboards'
    })
  }

  const items: ManageMenuItem[] = useMemo(() => {
    return [
      {
        title: 'Archive dashboard',
        confirmValue: 'delete',
        className: 'danger',
        onClick: () => {
          archiveDashboard()
        },
      }
    ]
  }, [])

  function exit() {
    window.location = `/admin/dashboards`
  }

  if (!loaded) {
    return <Loading />
  }

  return (
    <div className="builder">
      <div className="header editable-name-container margin-bottom double">
        <EditableName
          modelName="dashboard"
          name={name}
          endpoint={`/api/dashboards/${dashboardId}`}
        />
        <div className="actions">
          {status !== 'live' && (<>
            <ManageMenuComponent items={items} title="Manage" />
            <button
              onClick={() => exit()}
              className="button primary"
            >
              Finish later
            </button>
          </>)}
        </div>
      </div>

      <div className="steps">
        <Effort />
        <DashboardAccessAndAudience />
        <Instructions />
        <DashboardFields />
        <Settings />
        <Preview />
        {status !== 'draft' && (
          <button 
            className="button secondary margin-top" 
            onClick={() => window.location.href = `overview`}
          >
            <SvgIconsBack style={{ minHeight: 12 }} />
            Back to dashboard overview
          </button>
        )}
      </div>
    </div>
  )
}
